/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgPills = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="m4.292 18.294 4.002-4.002a3.001 3.001 0 0 0-4.002 4.002zm5.416-2.587-4.002 4a3.001 3.001 0 0 0 4.002-4zm-6.244 4.829a5 5 0 1 1 7.071-7.072 5 5 0 0 1-7.07 7.072zM8.172 3.172a4 4 0 0 1 5.656 0l7.072 7.07a4 4 0 0 1-5.657 5.657L8.172 8.83a4 4 0 0 1 0-5.657zm4.242 1.414a2 2 0 1 0-2.828 2.828l2.828 2.829 2.829-2.829z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgPills as Pills };
